export const palette = [
  { stroke: "#0a1464", fill: "rgba(10, 20, 100, 1)" },      // Power Blue
  // { stroke: "#5591f5", fill: "rgba(85, 145, 245, 1)" },     // Hydro Blue
  { stroke: "#216ef2", fill: "rgba(33, 110, 242, 1)" },     // Accessible Hydro Blue
  { stroke: "#82e1d7", fill: "rgba(130, 225, 215, 1)" },    // Electric Turquoise
  { stroke: "#78d278", fill: "rgba(120, 210, 120, 1)" },    // Energising Green
  { stroke: "#2be3da", fill: "rgba(43, 227, 218, 1)" },     // Icon Turquoise
  { stroke: "#2a3745", fill: "rgba(42, 55, 69, 1)" },       // Dark Grey
  { stroke: "#c6d3dc", fill: "rgba(198, 211, 220, 1)" },    // Mid Grey
  { stroke: "#c98bdb", fill: "rgba(201, 139, 219, 1)" },    // Illustration Purple
  { stroke: "#fce727", fill: "rgba(252, 231, 39, 1)" },     // Illustration Yellow
  { stroke: "#000000", fill: "rgba(0, 0, 0, 1)" },          // Black
];

export function colorForIndex(index: number) {
  return palette[index % palette.length];
}
